module.exports = __webpack_public_path__ + "media/images/flags/4x3/brn-f964b0730c98719e52effee8aef7c31f.svg";